import React from "react";
import { RecoilRoot } from "recoil";
import { ChainlitContext, ChainlitAPI } from "@chainlit/react-client";
import { getChainlitApiUrl } from "../services/chainlitUrls";

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  const chainlitAPI = new ChainlitAPI(getChainlitApiUrl(), "webapp");

  return (
    <RecoilRoot>
      <ChainlitContext.Provider value={chainlitAPI}>
        {children}
      </ChainlitContext.Provider>
    </RecoilRoot>
  );
};

export default AppProviders;
